import { render, staticRenderFns } from "./supplyMarket.vue?vue&type=template&id=b2171682&scoped=true"
import script from "./supplyMarket.vue?vue&type=script&lang=js"
export * from "./supplyMarket.vue?vue&type=script&lang=js"
import style0 from "./supplyMarket.vue?vue&type=style&index=0&id=b2171682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2171682",
  null
  
)

export default component.exports